import React, { lazy, Suspense } from "react";

const Page = lazy(() => import("../Home/HomeMFE"));

export default () => (
  <Suspense fallback={null}>
    <Page />
  </Suspense>
);
